import { useEffect } from 'react';
import { IVehiclePageProps } from '../../interfaces';
import { IOrder } from 'next-common';
import { useClientLazyQuery } from '../useClientLazyQuery';
import { NEXT_ENTITY, QUERY_VARIANT } from '@common/interfaces/entity';
import { API_CACHE_POLICY } from 'types';
import { setOrder } from '@store/slices/orderSlice';
import { useAppDispatch } from '@store/hooks';
import { setCustomer } from '@store/slices/customerSlice';

export const useClientOrder = (props: IVehiclePageProps): IOrder => {
  const { data } = useClientOrderQuery(props);
  return data;
};

const useClientOrderQuery = (props: IVehiclePageProps) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (props.orderId) {
      orderData();
    }
  }, [props.orderId, props.pimId]);

  const [orderData, { loading, data }] = useClientLazyQuery(NEXT_ENTITY.ORDER, {
    variables: { id: props.orderId },
    queryVariant: QUERY_VARIANT.CONCISED,
    nextOptions: { cache: API_CACHE_POLICY.NO_STORE },
  });

  useEffect(() => {
    if (!loading) {
      dispatch(setOrder(data));
      dispatch(setCustomer(data?.customer));
    }
  }, [loading, data]);

  return { data, loading };
};
